/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisionReasonRequest
 */
export interface RevisionReasonRequest {
    /**
     * 
     */
    expected_revision: number;
    /**
     * 
     */
    reason: string;
}

/**
 * Check if a given object implements the RevisionReasonRequest interface.
 */
export function instanceOfRevisionReasonRequest(value: object): value is RevisionReasonRequest {
    if (!('expected_revision' in value) || value['expected_revision'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function RevisionReasonRequestFromJSON(json: any): RevisionReasonRequest {
    return RevisionReasonRequestFromJSONTyped(json, false);
}

export function RevisionReasonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisionReasonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_revision': json['expected_revision'],
        'reason': json['reason'],
    };
}

export function RevisionReasonRequestToJSON(json: any): RevisionReasonRequest {
    return RevisionReasonRequestToJSONTyped(json, false);
}

export function RevisionReasonRequestToJSONTyped(value?: RevisionReasonRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_revision': value['expected_revision'],
        'reason': value['reason'],
    };
}

